import React from "react";
import { UseCase } from "./UseCase";
import { IUseCaseModel } from "./UseCase";

export interface IUseCaseCategoryViewProps {
    useCases: IUseCaseModel[];
}

export const UseCaseCategoryView: React.FunctionComponent<IUseCaseCategoryViewProps> = ({
    useCases
}: IUseCaseCategoryViewProps) => {
    return (
        <div>
            {useCases.map(useCase => {
                return <UseCase key={useCase.name} useCase={useCase} />;
            })}
        </div>
    );
};
